import { render } from "./UiBlock.vue?vue&type=template&id=73c9abd1"
import script from "./UiBlock.vue?vue&type=script&lang=js"
export * from "./UiBlock.vue?vue&type=script&lang=js"

import "./UiBlock.vue?vue&type=style&index=0&id=73c9abd1&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__